
import library from './plugins/library'
import store from './options/store'
import { eventHub } from '@/plugins/eventHub'
import { Vue } from 'vue-class-component'
import service from '@/options/service'
import { ResponseData } from '@/type'
import URL from '@/options/url'

const allowSystemName = [ // 允许接入word组件的化的业务系统
  { systemCode: 100001, description: '在线文档', beanName: 'docOnlineSystemSourceStrategy', name: 'doc' },
  { systemCode: 100001, description: '文档库', beanName: 'docLibSystemSourceStrategy', name: 'docOnline' },
  { systemCode: 100002, description: '合同', beanName: 'contractSystemSourceStrategy', name: 'chengben' },
  { systemCode: 100003, description: '会议', beanName: 'meetingSystemSourceStrategy', name: 'huiyi' },
  { systemCode: 100004, description: '动态', beanName: 'dynamicSystemSourceStrategy', name: 'dongtai' },
  { systemCode: 100005, description: '知识库', beanName: 'knowledgeSystemSourceStrategy', name: 'zhishiku' },
  { systemCode: 100006, description: '团队笔记', beanName: 'teamNoteSystemSourceStrategy', name: 'zhishiku-wiki' },
  { systemCode: 100016, description: '工作报告', beanName: 'teamNoteSystemSourceStrategy', name: 'zhishiku-report' },
  { systemCode: 100007, description: 'DTM项目管理', beanName: 'dtmSystemSourceStrategy', name: 'DTM'},
  { systemCode: 100008, description: '产品策略', beanName: 'productPolicySystemSourceStrategy', name: 'chanpincelue'},
  { systemCode: 100009, description: 'PLM', beanName: 'plmSystemSourceStrategy', name: 'PLM'},
  { systemCode: 100010, description: '猎鹰', beanName: 'defaultSystemSourceStrategy', name: 'lie-ying'},
  { systemCode: 100011, description: '营销指挥仓', beanName: 'defaultSystemSourceStrategy', name: 'yingxiao-zhihuichang'},
  { systemCode: 100012, description: '往来函件', beanName: 'defaultSystemSourceStrategy', name: 'wanglai-hanjian'},
  { systemCode: 100013, description: '龙智造航道经营平台', beanName: 'defaultSystemSourceStrategy', name: 'C5SJGL'},
  { systemCode: 200001, description: '任务', beanName: 'taskSystemSourceStrategy', name: 'task'}
]

function handleBrowserCompatibility(): void {
  const ua = library.getUserAgentInfo()
  const part1 = ua.name === ''
  const part2 = ua.name === 'chrome' && ua.version < 69
  const part3 = ua.name === 'safari' && ua.version < 12
  const part4 = ua.name === 'edge' && ua.version < 79
  if (part1 || part2 || part3 || part4) {
    store.commit('setDocAuth', { code: '111', data: {} })
  }
  store.commit('setClient', ua)
}

function handleMessageData(data: any, e: any): void {
  const messageType = data.messageType

  const messageTypeMapper: Record<string, any> = {
    onFullScreen: 'onFullScreen',
    offFullScreen: 'offFullScreen',
    byExcelFileToJson: 'byExcelFileToJson',
    mergeExcelData: 'mergeExcelData',
    locateExcelCell: 'locateExcelCell',
    previewFile: 'previewFile',
    saveExcelVersion: 'saveExcelVersion',
    exportExcel: 'exportExcel',
    exportPdf: 'exportPdf',
    exportDocx: 'exportDocx',
    openHistory: 'openHistory',
    activeValid: 'activeValid',
    getAllImage: 'getAllImage',
    'pushTask-confirm': 'pushTaskConfirm',
    pushTask: (): void => {
      if (data.message === 'closeTaskPopup') {
        const taskWrapper = document.querySelector('.dialog-task-detail')
        if (taskWrapper) {
          document.body.removeChild(taskWrapper)
        }
      } else {
        store.commit('setPushTaskData', data)
      }
    },
    // 获取文档id
    getDocId: (): void => {
      // 接收消息
      // {
      //   'appName': 'DTM',
      //   'appOrigin': 'https://dtm.longfor.com',
      //   'messageType': 'getDocId'
      // }
      // 准备回复消息
      const reply = { messageType: data.messageType, data: { docId: store.state.docInfo?.fileId || '' } }
      // 回复消息给特定的来源和目标窗口（可选）
      e.source.postMessage(reply, e.origin)
    }
  }

  if (messageTypeMapper[messageType]) {
    const typeValue = messageTypeMapper[messageType]

    // 直接处理
    const isEventFun = messageType === 'pushTask' || messageType === 'getDocId'

    // 处理事件
    isEventFun ? typeValue() : eventHub.emit(typeValue, data)
  } else if (data.appName) {
    eventHub.emit('outerSystemInit', data)
  }
}

export default class App extends Vue {
  beforeCreate(): void {
    const href = window.location.href
    if (href.includes('/excel/')) {
      const docId = window.location.pathname.replace('/excel/', '')

      if (docId) {
        service
          .get(URL.getDocData, {
            params: {
              fileId: docId
            }
          }).then((res: ResponseData) => {
            if (res && res.code === '200' && res.data.editorVersion === 'SP16') {
              window.location.href = href.replace('/excel/', '/new/excel/')
            }
          })
      }
    }

    // 判断浏览器是否兼容
    handleBrowserCompatibility()

    // 监听业务方的 iframe 嵌套
    window.addEventListener('message', (e) => {
      const eventData = e?.data ?? {}
      const validMessage = JSON.stringify(eventData).indexOf('setImmediate') < 0

      if (!validMessage) return

      // 存储 appName（没有 appName 无法进行消息处理）
      const appName = eventData.appName
      const outerSystemData = allowSystemName.find((v) => v.systemCode + '' === appName + '' || v.name === appName + '')

      if (appName && outerSystemData) {
        store.commit('setOuterSystemData', outerSystemData)
        // 处理埋点
        const { description } = outerSystemData
        window.zhuge.track('页面PV', { 页面分类: `组件化页面-${description}` })
      }

      // 接收消息功能处理
      if (store.state.outerSystemData) {
        handleMessageData(eventData, e)
      }
    }, false)
  }

  mounted() {
    // 去掉初始化loading
    if (window.location.href.indexOf('/excel/') < 0 && window.location.href.indexOf('/word/') < 0) {
      const fpLoading = document.getElementById('app-loading')
      if (fpLoading) {
        fpLoading.style.display = 'none'
      }
    }
  }
}
